import { useQuery } from '@apollo/client';
import { GetObligationImpactsByParentIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetObligationImpactsByParentId as useGetObligationImpactsByParentIdTRPC } from './useGetObligationImpactsByParentIdTRPC';

export const useGetObligationImpactsByParentId = (
  parentId: string,
  options?: { skip?: boolean; onError?: (error: Error) => void }
) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { skip = false, onError } = options || {};

  // Use TRPC when feature flag is enabled, otherwise use GraphQL
  const trpcResult = useGetObligationImpactsByParentIdTRPC(parentId, options);
  const graphqlResult = useQuery(GetObligationImpactsByParentIdDocument, {
    variables: { _eq: parentId },
    skip: trpcEnabled || skip,
    fetchPolicy: 'no-cache',
    onError,
  });

  return trpcEnabled ? trpcResult : graphqlResult;
};
